import {Type} from 'class-transformer';

import {EntityArray} from '../../core/entityArray';
import {Helper} from '../../helpers/helper';
import {LookinChatSDK} from '../../lib/lookinChatSDK';
import {CaseMetadata} from '../caseMetadata';
import {Request} from '../request';

import {GroupContent} from './groupContent';
import {GroupState, GroupStateType} from './groupState';
import {GroupUser} from './groupUser';

/**
 * @ignore
 * @internal
 * */
export class GroupRequest extends Request {
  type: GroupStateType[] = ['create']
  groupId: string;
  clientId: string;

  @Type(() => CaseMetadata)
  caseMetadata: CaseMetadata = null;

  @Type(() => GroupRequestData)
  data: GroupRequestData = new GroupRequestData();

  constructor(type: GroupStateType[] = ['create'], state: GroupState = null, groupId: string = null) {
    super();

    this.type = type;
    this.groupId = groupId;

    this.data = new GroupRequestData(state)
    this.clientId = Helper.getRandomClientId(this.groupId + LookinChatSDK.user.id);
  }

  isType(type: GroupStateType) {
    return this.type.includes(type);
  }
}

class GroupRequestData {
  state: EntityArray<GroupState> = new EntityArray<GroupState>();
  content?: GroupContent;
  users?: GroupUser[];
  user?: GroupUser;

  constructor(state: GroupState = null) {
    if (state) {
      this.state.push(state);
    }
  }
}
